import { createContext } from "react";

const FeesTemplateContext = createContext<any>({});

export default FeesTemplateContext;
